<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/applicants">{{$t('applicants.applicants')}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ form.last_name }} {{ form.first_name }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore"> {{$t('applicants.trashed_message')}}</trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :genders="genders" :nationalities="nationalities" :civil_states="civil_states" :languages="languages" :locations="locations"></Form>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{$t('global.delete')}}</button>
          <button v-if="data.deleted_at && $store.getters.can('admin')" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="forceDestroy">{{$t('global.force_delete')}}</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{$t('global.update')}}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
    genders: Array,
    nationalities: Array,
    civil_states: Array,
    languages: Array,
    locations: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        date_birth: this.data.date_birth,
        national_registry: this.data.national_registry,
        phone: this.data.phone,
        street: this.data.street,
        street_number: this.data.street_number,
        zip_code: this.data.zip_code,
        city: this.data.city,
        gender_id: this.data.gender_id,
        nationality_id: this.data.nationality_id,
        civil_state_id: this.data.civil_state_id,
        language_ids: this.data.language_ids,
        language_field: this.data.language_field,
        note: this.data.note,
        birth_place: this.data.birth_place,
        email: this.data.email,
        residence_permit: this.data.residence_permit,
        income: this.data.income,
        mutuality: this.data.mutuality,
        syndicate: this.data.syndicate,
        closed: this.data.closed,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/applicants/${this.data.id}`)
        }
      })
    },
    forceDestroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/applicants/${this.data.id}/force`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/applicants/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
